import { AdCarousel, AdCarouselProps } from '../../components/ad/ad-carousel'
import { CarouselGroupAdBlock } from './carousel-group-ad.block'

export const CarouselGroupAdComponent = (block: CarouselGroupAdBlock) => {
  const componentProps: AdCarouselProps = {
    id: block.id,
    items: block.ads.map((item) => ({
      id: item.id,
      title: item.title,
      description: item.description,
      ctaLabel: item.linkText,
      href: item.link,
      image: item.image,
    })),
  }

  return <AdCarousel {...componentProps} />
}
